module.exports = __webpack_public_path__ + "static/VTFMisterPixel-Tools-ff668733b35a887b08ffda913ac726eb.woff";